import type { FaireProductEntity } from "../../entity_types/product";

export const p_ef5dx3smxy: FaireProductEntity = {
  token: "p_ef5dx3smxy",
  type: "product",
  name: "Slim Fit Satin Midi Dress",
  brandToken: "b_1udwajl633",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/971a1f63f8f74fa963ff22c69a0f0e968d5ed3238d3c47d4198c76521bd96ace.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31f3cb3c397f18fbd5a22bcd969b26b1265cda8813d48f5c373aedb42096c075.jpeg",
    "https://cdn.faire.com/fastly/ebeb27990b363ce31e62ae62f695bb21907e637a4e3f96723b9b03d567536da0.jpeg",
    "https://cdn.faire.com/fastly/b6e86b5deca0faac92c6845a25e7e951bf8bb83bdd27eac0d4609a0d4cfeae20.jpeg",
    "https://cdn.faire.com/fastly/77dded6c5d98e3519976851f8ec1824f1af41b914b2959dda80b047e343dd7b5.jpeg",
    "https://cdn.faire.com/fastly/efae649d637c45f78640ff32a96175e1ba6d96392d651d79002d2d2440adfdd6.jpeg",
    "https://cdn.faire.com/fastly/4d7ae0889949c59f07a32c56b66858b68d41197e468b1eac4a8d9fff7b67435a.jpeg",
    "https://cdn.faire.com/fastly/a4559bf815d9b26d2402980b669e79d7038cab0a4bf05209c923e7784fa04a1b.jpeg",
    "https://cdn.faire.com/fastly/5380e57d57ad44b7099cad8202d50e3168f216fbe01076926763eb72fc5d8d25.jpeg",
    "https://cdn.faire.com/fastly/aa2d8c568781d2ff8da532ee94b11e1db63bd35fe32b3d1cac48de90605918af.jpeg",
    "https://cdn.faire.com/fastly/3c2b95be05bd875ed5c3a7fa55e89c40304c79ee458e183265aceeba257c3b73.jpeg",
    "https://cdn.faire.com/fastly/88abe7e79bef3cf9226f0d386a9ad9edd2bee8560062344a6b991f8b6957288c.jpeg",
    "https://cdn.faire.com/fastly/163c7c10e2de6506116317a160b396715ba2ce564d0e54978156ce7f052ba085.jpeg",
    "https://cdn.faire.com/fastly/f4a87dbb3604cec2040893f33edc1dd4ad0d826a6d1a61741843b5804946138c.jpeg",
    "https://cdn.faire.com/fastly/e39651a82c77690345534b94d0bae02fe2d05bb8cd99ffd28f3256450f740d1e.jpeg",
    "https://cdn.faire.com/fastly/358e7a8cbc21bd559c1502e07fa2d3c7f3b9063ed6fd50307ca9895f84623c8b.jpeg",
    "https://cdn.faire.com/fastly/2ca7e37b5b3ee4450e00186556b5a3c6dce4b6293860bc6e9fdda40d343997a2.jpeg",
  ],
  priceDollars: 27.37,
  description:
    "BD103 - Fitted satin slip gown with tie shoulders, cowl neckline and mid length tea cut. ",
  tags: [],
  msrpDollars: 54.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:31.065Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
